import { Component, OnInit, OnDestroy, ChangeDetectorRef } from "@angular/core";
import { CoreService } from "src/app/services/core.service";
import { AppSettings } from "src/app/config";
import { CommonModule } from "@angular/common";
import { RouterOutlet, Router, NavigationEnd } from "@angular/router";
import { Subscription } from "rxjs";
import { filter } from "rxjs/operators";
import { WebSocketNotificationOrchestratorService } from "src/app/shared/services/websocket-notification-orchestrator.service";

@Component({
  selector: "app-blank",
  templateUrl: "./blank.component.html",
  styleUrls: ["./blank.component.scss"],
  imports: [RouterOutlet, CommonModule],
})
export class BlankComponent implements OnInit, OnDestroy {
  private htmlElement!: HTMLHtmlElement;
  private settingsSubscription!: Subscription;
  private routerSubscription!: Subscription;

  options = this.settings.getOptions();

  constructor(
    private settings: CoreService,
    private cdr: ChangeDetectorRef,
    private router: Router,
    private wsOrchestrator: WebSocketNotificationOrchestratorService,
  ) {
    this.htmlElement = document.querySelector("html")!;
    this.receiveOptions(this.options);
  }

  ngOnInit() {
    void this.wsOrchestrator.initialize();

    this.settingsSubscription = this.settings.notify.subscribe(() => {
      this.receiveOptions(this.settings.getOptions());
      this.cdr.detectChanges();
    });

    this.routerSubscription = this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        this.receiveOptions(this.settings.getOptions());
        this.cdr.markForCheck();
      });
  }

  ngOnDestroy() {
    if (this.settingsSubscription) {
      this.settingsSubscription.unsubscribe();
    }
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }

  receiveOptions(options: AppSettings): void {
    this.options = options;
    this.applyTheme(options);
  }

  applyTheme(options: AppSettings): void {
    // Blank layout is always light; user theme preference applies only on Full layout.
    this.htmlElement.classList.remove("dark-theme");
    this.htmlElement.classList.add("light-theme");

    this.htmlElement.classList.forEach((className) => {
      if (className.endsWith("_theme")) {
        this.htmlElement.classList.remove(className);
      }
    });

    if (options.activeTheme) {
      this.htmlElement.classList.add(options.activeTheme);
    }
  }
}
